import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Document.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "react-bootstrap/Dropdown";
import { faCog, faDownload, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function Document({ id, user, title, downloadUrl, handleDownloadDocument }) {
  const { t } = useTranslation();

  return (
    <Row className="document align-items-center">
      <Col xs={11}>
        <h6>{title}</h6>
      </Col>
      <Col lg={1} className="person-content">
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
            <FontAwesomeIcon icon={faCog} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => handleDownloadDocument(downloadUrl)}>
              <FontAwesomeIcon icon={faDownload} />{" "}
              {t("Personas.Persona.Documento.Descargar")}
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to={`/people/${user}/document/delete/${id}`}
            >
              <FontAwesomeIcon icon={faTrash} />{" "}
              {t("Personas.Persona.Documento.Eliminar")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
}

export default Document;
